<!-- 已参与弹窗 -->
<template>
  <div class="join-popup">
    <van-overlay :show="show" @click="close" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <p class="text1">{{ msg }}</p>
        <div class="btn" @click="close">
          <span>知道了</span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { toWeChatClaim } from './community'
export default {
  components: {},
  props: ['prize',],
  data() {
    return {
      show: false,
      msg: ''
    }
  },
  computed: {

  },
  methods: {
    close() {
      this.setShow(false)
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.join-popup {
  position: relative;
  text-align: center;

  .wrapper {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    margin: 0 30px 0 30px;
    width: -webkit-fill-available;
    background: #3f92e3;
    border-radius: 51px;
    border: 11px solid #fffeff;
    text-align: center;
    .text1 {
      padding: 40px 10px 10px 10px;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }
    .gift {
      width: 65px;
    }
    .btn {
      border: 3px solid #fff;
      border-radius: 30px;
      margin: 20px auto 30px auto;
      width: 160px;
      span {
        display: block;
        line-height: 2.5;
        border-radius: 30px;
        border: 3px solid #000;
        background: #ffffff;
        font-size: 21px;
        font-weight: 600;
        color: #000000;
      }
    }
    .error-msg {
      font-weight: 600;
      color: #000000;
      padding: 40px 10px 40px 10px;
      font-size: 18px;
      line-height: 1.5;
    }
  }
  .close {
    width: 35px;
  }
}
</style>
